module.exports = __webpack_public_path__ + "static/media/logo.3be7141e.svg";